export default "__VITE_ASSET__DEDRYZUO__"